import { css } from "@emotion/react";
import styled from "@emotion/styled";
var selectSizeValue = function(size) {
    switch(size){
        case "tiny":
            return 0.5;
        case "large":
            return 1.25;
        case "small":
        default:
            return 1;
    }
};
var setSize = function(param) {
    var size = param.size;
    if (!size) {
        return null;
    }
    var sizeValue = selectSizeValue(size);
    return /*#__PURE__*/ css("width:", sizeValue, "rem;height:", sizeValue, "rem;");
};
var StyledSvg = /*#__PURE__*/ styled("svg", {
    target: "en5bw9d0"
})("width:100%;height:100%;", setSize);
export { StyledSvg };
